<script setup lang="ts">
import BarcodeForm from './components/BarcodeForm.vue'
import PinForm from './components/PinForm.vue'
import HealthDataForm from './components/HealthDataForm.vue'
import ThankYou from './components/ThankYou.vue'

import CollapsibleItem from './components/CollapsibleItem.vue'

import Counter1 from '@material-symbols/svg-400/rounded/counter_1-fill.svg';
import Counter2 from '@material-symbols/svg-400/rounded/counter_2-fill.svg';
import Counter3 from '@material-symbols/svg-400/rounded/counter_3-fill.svg';
import DoneAll from '@material-symbols/svg-400/rounded/verified-fill.svg';
import Done from '@material-symbols/svg-400/rounded/check_circle-fill.svg';

const { VITE_APP_TITLE, VITE_APP_SUBTITLE } = import.meta.env

import { ref, shallowRef } from 'vue'

let steps = [
  { svgIcon: Counter1, title: 'Barcode validation', component: BarcodeForm, enabled: true },
  { svgIcon: Counter2, title: 'Security PIN', component: PinForm, enabled: false },
  { svgIcon: Counter3, title: 'Health data', component: HealthDataForm, enabled: false },
  { svgIcon: DoneAll, title: 'Finish', component: ThankYou, enabled: false }
]

let step = ref(0)

let component = shallowRef(steps[step.value].component)

function changeStep(direction: number) {
  step.value = (step.value + direction) % steps.length
  steps[step.value].enabled = true
  component.value = steps[step.value].component
  if (step.value == steps.length - 1) {
    for (let i = 0; i < steps.length - 1; i++) {
      steps[i].enabled = false;
    }
  }
}

function handleNext() {
  changeStep(+1);
}

// function handlePrevious() {
//   changeStep(-1);
// }

function onStepClick(idx: number) {
  let isEnabled = steps[idx].enabled;
  if (isEnabled) {
      step.value = idx;
  }
}


</script>

<template>
<div class="page">
  <main class="content">
    <div class="mx-auto max-w-md">
      <header class="flex items-center divide-x space-x-4">
          <img src="/logo_full.png" class="h-12" alt="Lundoch Diagnostics logo" />
          <div class="pl-4">
            <div class="lg:text-2xl text-lg dark:text-gray-300">{{ VITE_APP_TITLE }}</div>
            <div class="lg:text-lg text-sm dark:text-gray-300">{{ VITE_APP_SUBTITLE }}</div>
          </div>
      </header>
      <div class="">
        <div class="space-y-6 py-8 text-base leading-7 text-gray-600">
          <p class="dark:text-gray-300">Please complete the steps below to register your testkit.</p>
        </div>
        <div class="divide-y divide-gray-300/50">
            <div class="" v-bind:key="s.title" v-for="(s, idx) in steps" :value="idx" :disabled="!s.enabled">
                <CollapsibleItem :enabled="s.enabled" :expanded="step == idx" :icon="idx >= step ? s.svgIcon : Done" :title="s.title" @on-click-title="() => onStepClick(idx)">
                  <component :is="s.component" @on-click-next="handleNext" />
                </CollapsibleItem>
            </div>
        </div>
      </div>
    </div>
  </main>
</div>
</template>

<style scoped>

</style>
